import { Badge, Tag } from '@chakra-ui/react'

import { STATUSES } from '../../../constants'

const CaseworkStatus = ({ status, variant }) => {
  const props = {
    bg: STATUSES[status]?.color,
    _dark: STATUSES[status]?._dark,
    color: 'offWhite',
    textTransform: 'uppercase',
  }

  if (variant === 'badge') {
    return (
      <Badge variant='solid' p={1} mr={1} {...props}>
        {status}
      </Badge>
    )
  }
  return <Tag {...props}>{status}</Tag>
}

export default CaseworkStatus
